import moment from 'moment';
import React from 'react';
import Parser from 'html-react-parser';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../constant';

const StepFour = (props) => {

    const onSubmit = (id) => {
        debugger
        props.onSubmit({ LISTNING_TYPE: id, JOB_ID: props.Data.JOB_ID })
    }
    return (
        <React.Fragment>
            <section className="pricing-area padding-bottom-80px">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-heading text-center">
                                <h2 className="sec__title_head">Choose a job basis your hiring needs</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row margin-top-35px dest-section">
                        <div className="col-lg-12">
                            <div className="row d-flex package">
                                {[
                                    {
                                        title: 'Regular Job',
                                        suitedFor: 'upto 1 hire*',
                                        validity: 'Job valid for 15 days',
                                        benefits: [
                                            'Smart boost via Whatsapp',
                                            'Higher visibility to candidates',
                                            'Urgently hiring tag',
                                        ],
                                        id: 1
                                    },
                                    {
                                        title: 'Featured job',
                                        suitedFor: 'upto 2 hires*',
                                        validity: 'Job valid for 15 days',
                                        benefits: [
                                            'Smart boost via Whatsapp',
                                            'Higher visibility to candidates',
                                            'Urgently hiring tag',
                                        ],
                                        recommended: true,
                                        id: 2

                                    },
                                    {
                                        title: 'Premium job',
                                        suitedFor: 'upto 4 hires*',
                                        validity: 'Job valid for 15 days',
                                        benefits: [
                                            '2x Smart boost via Whatsapp',
                                            '2x Higher visibility to candidates',
                                            'Urgently hiring tag',
                                        ],
                                        id: 3

                                    },
                                ].map((plan, index) => (
                                    <div className="col-lg-4 pr-2 sq-dbm1" key={index}>
                                        <div className={`package-item sq-dbm1`}>
                                            <div className="price margin-bottom-20px sq-dbm1">
                                                <h3 className="price__title sq-dbm1">{plan.title}</h3>
                                                <p>Suited for {plan.suitedFor}</p>
                                                {/* <div className="package-info margin-top-20px sq-dbm1">
                                                    <span className="amount sq-dbm1">{plan.price}</span>
                                                </div> */}
                                                <h6 className="text-center pt-2 sq-dbm1">{plan.validity}</h6>
                                            </div>
                                            <ul className="list-items margin-bottom-50px pb-1 sq-dbm1">
                                                {plan.benefits.map((benefit, i) => (
                                                    <li key={i}>
                                                        <i className="la la-check-circle text-success" /> {benefit}
                                                    </li>
                                                ))}
                                            </ul>
                                            <div className="btn-box text-center mt-2 pt-5 sq-dbm1">
                                                <a
                                                    href="#"
                                                    onClick={() => {
                                                        onSubmit(plan.id)

                                                    }}
                                                    className="theme-btn w-100 sq-dbm1"
                                                >
                                                    Select
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default StepFour;
